"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTemporaryDir = createTemporaryDir;
const os = require("os");
const fs_1 = require("fs");
const path_1 = require("path");
const { mkdtemp } = fs_1.promises;
async function createTemporaryDir() {
    return await mkdtemp((0, path_1.join)(os.tmpdir(), 'snyk'));
}
//# sourceMappingURL=fs.js.map